import { LOCATION_CHANGE } from 'react-router-redux';
import { put, fork, takeEvery, all, select } from 'redux-saga/effects';

import {
  hideDocumentation,
  selectDocumentationState
} from 'modules/documentation';

function* handleLocationChange() {
  const documentationState = yield select(selectDocumentationState);
  if (documentationState.open) {
    yield put(hideDocumentation());
  }
}

function* watchRouterChange() {
  yield takeEvery(LOCATION_CHANGE, handleLocationChange);
}

export default function* root() {
  yield all([
    // when the router change, hide the documentation
    fork(watchRouterChange)
  ]);
}



// WEBPACK FOOTER //
// ./src/client/plugins/app/modules/sagas.js